<!--
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-14 14:35:25
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-25 10:26:41
-->
<template>
    <el-dialog
        custom-class="jy-use-dialog"
        :visible.sync="iShow"
        modal-append-to-body
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="380px"
        @close="closeAction"
    >
        <div class="user-comit-dialog">
            <img
                class="heades-title"
                v-if="!withoutAuth"
                src="../images/blue_login@2x.png"
                alt=""
            />

            <div v-if="withoutAuth" class="tips">请登录后查看全部内容哟～</div>

            <el-form class="form-main" ref="form" :model="form" label-width="0">
                <el-form-item
                    v-for="(item, index) in formData"
                    :key="index"
                    :rules="item.rules"
                    :prop="item.field"
                >
                    <el-input
                        v-if="item.sType === 'text'"
                        v-model="form[item.field]"
                        size="medium"
                        :placeholder="item.label"
                    >
                        <i
                            slot="prefix"
                            class="el-input__icon iconfont iconshouji"
                        ></i>
                    </el-input>

                    <div v-if="item.sType === 'forget'" class="input-li">
                        <el-input
                            v-model="form[item.field]"
                            :placeholder="item.label"
                            size="medium"
                            :type="item.inputType"
                        >
                            <i
                                slot="prefix"
                                class="el-input__icon iconfont iconmima"
                            ></i>
                            <i
                                slot="suffix"
                                v-if="item.inputType === 'text'"
                                class="el-input__icon iconfont iconzhengyan"
                                @click="item.inputType = 'password'"
                            ></i>
                            <i
                                slot="suffix"
                                v-if="item.inputType === 'password'"
                                class="el-input__icon iconfont iconbiyan"
                                @click="item.inputType = 'text'"
                            >
                            </i>
                        </el-input>
                        <div class="opt-btns" @click="forgetAction">
                            忘记密码？
                        </div>
                    </div>
                </el-form-item>

                <div class="action" v-if="withoutAuth">
                    <div class="commit-btn no-auth" @click="submitForm('form')">登录</div>
                    <div class="go-login">
                        已有账号？<span class="login" @click="_toRegister">立即注册</span>
                    </div>
                    <!-- <div class="register-btn mb__s" @click="_toRegister">立即注册</div> -->
                </div>
                <div class="action" v-else>
                    <div class="commit-btn mb__s" @click="submitForm('form')">登录</div>
                    <div class="register-btn" @click="_toRegister">立即注册</div>
                </div>
            </el-form>
        </div>
    </el-dialog>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
    props:{
        dialogVisible:{
            type:Boolean,
            default:true
        },
        withoutAuth: Boolean
    },
    data(){
        return {
            iShow:true,
            form:{
                sPhone: '',
                sPassword:''
            },
            formData: [
                {
                    label: "请输入手机号",
                    field: "sPhone",
                    sType: "text",
                    rules: [
                        {
                            trigger: "blur",
                            required: true,
                            validator: (rule, value, callback) => {
                                if (value === "") {
                                    callback(new Error("请填写手机号"));
                                } else {
                                    let pattern = /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                                        flag = pattern.test(value);
                                    if (!flag) {
                                        callback(new Error("格式不正确"));
                                    }
                                    callback();
                                }
                            },
                        },
                    ],
                },
                {
                    label: "请输入密码",
                    field: "sPassword",
                    sType: "forget",
                    inputType:'password',
                    rules: [
                        {
                            trigger: "blur",
                            required: true,
                            validator: (rule, value, callback) => {
                                if (value === "") {
                                    callback(new Error("请输入密码"));
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                    optType:'forgetPassword'
                },
            ],
        }
    },
    computed: {
        ...mapState('common', ['h5Path'])
    },
    watch:{
        dialogVisible:{
            immediate:true,
            handler(val){
                this.iShow = val;
            }
        }
    },
    methods:{
        ...mapMutations('common', {
            updateTriggerVipValidate: 'updateTriggerVipValidate'
        }),
        ...mapActions('user', {
            tologin: 'login',
        }),
        ...mapActions('common', {
            fetchUserInfo: 'fetchUserInfo'
        }),
        closeAction(){
            this.$emit('close');
        },
        _toRegister(){
            this.$emit('register','');
        },
        forgetAction(){
            this.$emit('forget','');
        },

        submitForm(formName) {
            let params = {
                sPassword: this.form.sPassword,
                sPhone: this.form.sPhone
            };
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let res = await this.tologin(params)
                    if (res.data.ErrorCode === 200) {
                        if (this.h5Path) {
                            const callbackUrl = this.h5Path.indexOf('?') > -1
                                ? `${this.h5Path}&token=${res.data.Data.sToken}`
                                : `${this.h5Path}?token=${res.data.Data.sToken}`
                            window.open(callbackUrl, '_self')
                        }
                        await this.fetchUserInfo()
                        this.updateTriggerVipValidate(true)
                        this.$router.push({
                            path: '/home'
                        })

                        this.$emit('close');

                    }else{
                        this.$message.error(res.data.ErrorMessage)
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>
